module.exports = __webpack_public_path__ + "static/media/1.c4cf882f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16462/1.jpg
// module id = 560
// module chunks = 0